/* Signage.inc redesign - lead submission.
   Every redesigned form (quote page, sign card flip forms, contact) sends through here so leads keep
   reaching the existing pipeline (submissions.signage.inc -> Airtable) with the same fields, uuid,
   tracking data and request signature as the current lead forms.
   Endpoints come from Theme settings > Signage.inc redesign (window.SG.endpoints). */
(function () {
  'use strict';
  var SG = window.SG || {};
  var EP = SG.endpoints || {};
  var ls = window.safeLocalStorage || window.localStorage;
  var ss = window.safeSessionStorage || window.sessionStorage;

  function get(k) { try { return ls.getItem(k) || ''; } catch (e) { return ''; } }
  function set(k, v) { try { ls.setItem(k, v); } catch (e) {} }

  function mintUuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /* same key the rest of the site uses, so partial and final rows line up */
  function uuid() {
    var u = get('qs_user_data');
    if (!u) { u = mintUuid(); set('qs_user_data', u); }
    return u;
  }

  /* backend expects +1 (555) 123-4567 */
  function phoneUS(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 10) d = '1' + d;
    if (d.length !== 11) return String(v || '').trim();
    return '+1 (' + d.substr(1, 3) + ') ' + d.substr(4, 3) + '-' + d.substr(7);
  }

  function append(fd, obj) {
    Object.keys(obj).forEach(function (k) {
      var v = obj[k];
      if (v === undefined || v === null) return;
      fd.append(k, v);
    });
  }

  /* Clarity tracker session (same session_uuid sent to clarity.signage.inc/api/tracker/events).
     The tracker loads async, so fall back to the cookie / storage it persists the id in. */
  function claritySessionUuid() {
    try { if (window.Clarity && Clarity.getSessionUuid()) return Clarity.getSessionUuid(); } catch (e) {}
    var m = document.cookie.match('(?:^|; )clarity_session_uuid=([^;]*)');
    if (m) return decodeURIComponent(m[1]);
    try { return ss.getItem('clarity_session_uuid') || ls.getItem('clarity_session_uuid') || ''; } catch (e) { return ''; }
  }

  /* ---- partial leads: saved as the visitor types, so abandoned forms are not lost ---- */
  var partial = { created: false, airtableId: null, timer: null, pending: {} };
  function partialSend(fields) {
    if (!EP.partial) return Promise.resolve(null);
    var fd = new FormData();
    fd.append('uuid', uuid());
    if (partial.created) fd.append('_method', 'PATCH');
    var csid = claritySessionUuid();
    if (csid) fd.append('session_uuid', csid);
    append(fd, fields);
    /* full page url, query string included (utm, gclid, ?type= / ?category=) */
    if (!fields.lead_page_url) fd.append('lead_page_url', location.href);
    var first = !partial.created;
    partial.created = true;
    return fetch(EP.partial, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.status === 409 ? {} : r.json(); })
      .then(function (d) {
        if (d && d.lead && d.lead.airtable_record_id) partial.airtableId = d.lead.airtable_record_id;
        return d;
      })
      .catch(function (e) { if (first) partial.created = false; return null; });
  }
  function savePartial(fields) {
    Object.keys(fields).forEach(function (k) { if (fields[k]) partial.pending[k] = fields[k]; });
    clearTimeout(partial.timer);
    partial.timer = setTimeout(function () {
      var f = partial.pending; partial.pending = {};
      /* any filled field opens the partial lead, not only email / phone */
      if (!Object.keys(f).length) return;
      f.lead_page = SG.leadPage || location.pathname;
      partialSend(f);
    }, 1200);
  }
  function resetSession() {
    set('qs_user_data', mintUuid());
    partial.created = false; partial.airtableId = null; partial.pending = {};
  }

  /* ---- final submission ----
     fields: name, email, phone_number, details, Size, sign_usage, sign_types, address, ...
     opts:   { files: [File], recordSource: 'Sign Categories', leadPage: '...' } */
  function submit(fields, opts) {
    opts = opts || {};
    var fd = new FormData();
    var u = uuid();
    var phone = phoneUS(fields.phone_number);
    append(fd, fields);
    fd.set('phone_number', phone);
    if (fields.sign_types) {
      fd.set('selected_sign_types', fields.sign_types);
      fd.set('signTypes', fields.sign_types);
    }
    if (fields.sign_category && !fields.category) fd.set('category', fields.sign_category);
    if (!fields.address) fd.set('address', '-');
    append(fd, {
      uuid: u,
      user_uuid: u,
      partial_airtable_record_id: partial.airtableId || undefined,
      lead_page: opts.leadPage || SG.leadPage || location.pathname,
      record_source: opts.recordSource || 'Redesign',
      lead_page_url: location.href,
      leadSource: (function () { try { return ss.getItem('currentURL') || ''; } catch (e) { return ''; } })(),
      first_click: get('first_click'),
      first_visit: get('first_visit'),
      visit_count: get('visit_count'),
      event_keys_data: get('event_keys_data'),
      location: get('location') || undefined,
      isProspects: get('isProspects') || 'false'
    });
    try {
      if (typeof window.getLeadTrackingData === 'function') fd.append('tracking_metadata', JSON.stringify(window.getLeadTrackingData() || {}));
    } catch (e) {}
    (opts.files || []).forEach(function (f) { if (f) fd.append('images[]', f); });

    var sig = typeof window._generateFormSig === 'function'
      ? window._generateFormSig(fields.email || '', fields.name || '')
      : { signature: '', timestamp: Math.floor(Date.now() / 1000) };

    return fetch(EP.lead, {
      method: 'POST',
      headers: { 'x-form-signature': sig.signature, 'x-form-timestamp': String(sig.timestamp) },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Server responded with ' + r.status);
        return r.json().catch(function () { return {}; });
      })
      .then(function (data) {
        /* the API answers 200 with {status:422, errors} for validation problems */
        if (data && data.status === 422) {
          var err = new Error('validation'); err.errors = data.errors || {}; throw err;
        }
        resetSession();
        /* opts.skipConversion (e.g. fastsigns test leads, as on Signs.inc): no conversion ping, no URL change */
        if (!opts.skipConversion) {
          if (typeof window.gtag_report_conversion === 'function') { try { window.gtag_report_conversion(); } catch (e) {} }
          try { history.replaceState(history.state, '', location.pathname + (location.search ? location.search + '&' : '?') + 'thanks-for-response'); } catch (e) {}
        }
        return data;
      })
      .catch(function (e) {
        if (typeof window.logClientError === 'function') window.logClientError('sg_lead_submit', e, u);
        throw e;
      });
  }

  /* contact form -> POST {SG.endpoints.contact} (submissions.signage.inc/api/contact), JSON.
     Same payload as the Signs.inc contact form (signs.inc sections/nt-contact-form-v1.liquid):
     type, name, email, phone, message, business, journeyCountry, lead_page_url, uuid, location
     plus the topic's own fields (sign_type, size, images[] for a mockup; order_number; consult_topic ...). */
  /* attribution fields, named as on nt-hero-quote-form-v2 (event_source is the stored event_keys_data) */
  function tracking() {
    var t = {};
    try { if (typeof window.getLeadTrackingData === 'function') t = window.getLeadTrackingData() || {}; } catch (e) {}
    var src = ''; try { src = ss.getItem('currentURL') || ''; } catch (e) {}
    return {
      first_click: get('first_click'),
      first_visit: get('first_visit'),
      visit_count: get('visit_count'),
      event_source: get('event_keys_data'),
      lead_source: src || '-',
      tracking_metadata: t
    };
  }

  function contact(fields) {
    var payload = {
      uuid: fields.uuid || mintUuid(),
      type: fields.type || 'General Inquiry',
      name: fields.name || '',
      email: fields.email || '',
      phone: fields.phone ? phoneUS(fields.phone) : '',
      business: fields.business || '',
      message: fields.message || '',
      page_url: location.href,
      lead_page_url: location.href,
      location: get('location') || get('ev_location_and_time'),
      journeyCountry: get('countryName'),
      record_source: fields.record_source || 'Contact Page'
    };
    var tr = tracking();
    Object.keys(tr).forEach(function (k) { payload[k] = tr[k]; });
    Object.keys(fields).forEach(function (k) { if (!(k in payload) && fields[k] !== undefined && fields[k] !== '') payload[k] = fields[k]; });
    return fetch(EP.contact, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Request failed with status ' + r.status);
        return r.json().catch(function () { return {}; });
      })
      .then(function (data) {
        /* as on nt-hero-quote-form-v2: the URL becomes <path>?thanks-for-response (any Google Ads params are dropped) */
        try { history.pushState({}, '', location.pathname + '?thanks-for-response'); } catch (e) {}
        return data;
      })
      .catch(function (e) {
        if (typeof window.logClientError === 'function') window.logClientError('sg_contact_submit', e, payload.uuid);
        throw e;
      });
  }

  window.SGLead = { submit: submit, contact: contact, tracking: tracking, savePartial: savePartial, phoneUS: phoneUS, uuid: uuid, newUuid: mintUuid };
})();
